module.exports = __webpack_public_path__ + "img/channel-cn.69807be5.png";